import MenuBar from './MenuBar';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

MenuBar.schema = schema;
MenuBar.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default MenuBar;
